import type { FC } from 'react';
import { Button } from '@mui/material';
import type { ButtonOwnProps } from '@mui/material/Button/Button';

import FollowUpIcon from 'src/assets/svg/followupinspirations/FollowUpIcon.svg?react';
import history from 'src/services/routing/history';
import { routePaths } from 'src/services/routing/routePaths';

export const FI_BUTTON_TEST_ID = 'fi-button';

interface FIButtonProps extends Pick<ButtonOwnProps, 'color' | 'variant'> {
  hideIcon?: boolean;
}

export const FIButton: FC<FIButtonProps> = ({
  color,
  variant = 'cta',
  hideIcon = false,
}) => {
  const href = history.createHref({
    pathname: routePaths.FOLLOW_UP_INSPIRATIONS,
  });

  return (
    <Button
      variant={variant}
      color={color}
      startIcon={!hideIcon ? <FollowUpIcon /> : null}
      onClick={() => window.open(href, '_blank')}
      data-test-id={FI_BUTTON_TEST_ID}
    >
      Follow-Up Inspirations
    </Button>
  );
};
